import { useQuery } from '@tanstack/react-query';
import { default as addressService } from "../services/address";
import useI18n from '@/hooks/useI18n';

export const useTipovias = () => {
  const { currentLang } = useI18n()

  return useQuery({
    queryKey: ['tipovias', currentLang.langCode],
    queryFn: () => addressService.fetchTipovias(),
    staleTime: 1000 * 60 * 30
  })
  
}